/**
 *
 * MeetingVideo
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import VideoLink from 'components/VideoConf/VideoLink.jsx';
import messages from './messages.js';
import { LOCATION_TYPE_VIDEO } from '../Planner/SelectLocationType/constants.js';
import InfoButton from '../../interaction/InfoButton/index.jsx';

function MeetingVideo(props) {
  const { meeting } = props;
  const { videoMeeting, meetingLocationType } = meeting;
  if (meetingLocationType !== LOCATION_TYPE_VIDEO) {
    return null;
  }
  return (
    <div className="mb-3">
      {videoMeeting && videoMeeting.link ? (
        <VideoLink {...videoMeeting} className="btn btn-default py-1">
          <FormattedMessage {...messages.joinVideo} />
        </VideoLink>
      ) : (
        <div className="text-muted">
          <FormattedMessage {...messages.noLinkYet} />
          <InfoButton>
            <FormattedMessage {...messages.noLinkYetInfo} />
          </InfoButton>
        </div>
      )}
    </div>
  );
}

MeetingVideo.propTypes = {
  meeting: PropTypes.object,
};

export default MeetingVideo;
